import axios from 'axios';
import AuthService from './auth-header';

let API_URL = ''
    if (process.env.NODE_ENV === "production") {
        API_URL = 'https://ats.sattvahuman.in/api/'
    } else {
        API_URL = 'http://192.168.0.30:5000/api/'
    }

class EnhancedInvoiceNotificationService {
    // Get notification schedule for an invoice
    async getNotificationSchedule(invoiceId) {
        try {
            const res = await axios.get(API_URL + 'invoice/' + invoiceId + '/notifications/schedule', {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Schedule notifications for an invoice based on credit period
    async scheduleNotifications(invoiceId, creditPeriod) {
        try {
            const data = {
                creditPeriod
            };
            const res = await axios.post(API_URL + 'invoice/' + invoiceId + '/notifications/schedule', data, {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Get all scheduled notifications for an invoice
    async getScheduledNotifications(invoiceId) {
        try {
            const res = await axios.get(API_URL + 'invoice/' + invoiceId + '/notifications', {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Trigger a specific notification manually
    async triggerNotification(invoiceId, notificationType) {
        try {
            const data = {
                notificationType
            };
            const res = await axios.post(API_URL + 'invoice/' + invoiceId + '/notifications/trigger', data, {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Cancel a scheduled notification
    async cancelNotification(invoiceId, notificationId) {
        try {
            const res = await axios.delete(API_URL + 'invoice/' + invoiceId + '/notifications/' + notificationId, {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Update notification status
    async updateNotificationStatus(invoiceId, notificationId, status) {
        try {
            const data = { status };
            const res = await axios.put(API_URL + 'invoice/' + invoiceId + '/notifications/' + notificationId + '/status', data, {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Get notification history for an invoice
    async getNotificationHistory(invoiceId) {
        try {
            const res = await axios.get(API_URL + 'invoice/' + invoiceId + '/notifications/history', {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Get all invoices with pending notifications
    async getInvoicesWithPendingNotifications() {
        try {
            const res = await axios.get(API_URL + 'invoice/notifications/pending', {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Get notification templates
    async getNotificationTemplates() {
        try {
            const res = await axios.get(API_URL + 'invoice/notifications/templates', {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Send test notification
    async sendTestNotification(invoiceId, templateId, recipientEmail) {
        try {
            const data = {
                templateId,
                recipientEmail
            };
            const res = await axios.post(API_URL + 'invoice/' + invoiceId + '/notifications/test', data, {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }
}

export default new EnhancedInvoiceNotificationService();
